// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconPadding {
  padding-right: 10px;
}
.selected {
  background-color: #ECBBC7;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/DataCard.less"],"names":[],"mappings":"AAEA;EACE,mBAAA;AADF;AAIA;EACE,yBAAA;AAFF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.iconPadding {\n  padding-right: 10px;\n}\n\n.selected {\n  background-color: #ECBBC7;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
